import { getSalonAdminApiBaseUrl } from '../../salon-admin/utils/apiConfig';
import { buildHqSessionHeaders, hqSessionFetchInit } from '../../admin-shared/hqSessionAuth';
import { PORTAL_ID } from './api';

function adminBase() {
  return (getSalonAdminApiBaseUrl() || '').replace(/\/$/, '');
}

function hasPartnerSession() {
  return Boolean(localStorage.getItem('naturals_partner_userId'));
}

/**
 * @param {{ segment?: string, search?: string, limit?: number, offset?: number }} params
 */
export async function fetchPartnerCustomers({ segment = 'all', search = '', limit = 50, offset = 0 } = {}) {
  const base = adminBase();
  if (!base || !hasPartnerSession()) {
    throw new Error('Not authenticated');
  }
  const qs = new URLSearchParams();
  if (segment && segment !== 'all') qs.set('segment', segment);
  if (search) qs.set('search', search);
  qs.set('limit', String(limit));
  qs.set('offset', String(offset));

  const res = await fetch(`${base}/partner/customers?${qs.toString()}`, hqSessionFetchInit(PORTAL_ID));
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data?.success) {
    throw new Error(data?.error || 'Failed to load customers');
  }
  return data;
}

export async function fetchPartnerCustomerAnalytics({ fromDate, toDate } = {}) {
  const base = adminBase();
  if (!base || !hasPartnerSession()) {
    throw new Error('Not authenticated');
  }
  const qs = new URLSearchParams();
  if (fromDate) qs.set('fromDate', fromDate);
  if (toDate) qs.set('toDate', toDate);

  const res = await fetch(
    `${base}/partner/customers/analytics?${qs.toString()}`,
    hqSessionFetchInit(PORTAL_ID),
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data?.success) {
    throw new Error(data?.error || 'Failed to load customer analytics');
  }
  return data.analytics || {};
}

export async function fetchPartnerCustomerDetail(faceUserId) {
  const base = adminBase();
  if (!base || !hasPartnerSession()) {
    throw new Error('Not authenticated');
  }
  const id = String(faceUserId || '').trim();
  if (!id) throw new Error('Customer id is required');

  const res = await fetch(`${base}/partner/customers/${encodeURIComponent(id)}`, hqSessionFetchInit(PORTAL_ID));
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data?.success) {
    throw new Error(data?.error || 'Failed to load customer');
  }
  return data.customer;
}

export const CUSTOMER_SEGMENTS = [
  { id: 'all', label: 'All customers' },
  { id: 'vip', label: 'VIP / High value' },
  { id: 'loyal', label: 'Loyal' },
  { id: 'at_risk', label: 'At risk' },
  { id: 'new', label: 'New' },
  { id: 'regular', label: 'Regular' },
];

export function segmentLabel(segment) {
  const hit = CUSTOMER_SEGMENTS.find((s) => s.id === segment);
  return hit?.label || segment || 'Customer';
}

export function segmentBadgeClass(segment) {
  const key = String(segment || 'regular').toLowerCase();
  return `pcust-segment pcust-segment--${key}`;
}
